import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

//Models
import { ClockIn } from '../../modules/sbsuite/models/clock-in.model';
import { BoundTextAst } from '@angular/compiler';

declare var google;

/**
 * Componente Modal para mostrar Maps localización fichada
 * Cal executar,  npm install @types/googlemaps --save-dev
 * @export
 * @class MapLocationModal
 */
@Component({
  selector: 'page-maplocation-modal',
  templateUrl: 'maplocation.modal.html'
})
export default class MapLocationModal {

  @ViewChild('map') mapElement: ElementRef;
  map: any;
  public markers: any[] = [];
  private mapsLoaded: boolean = false;
  private networkHandler = null;

  directionsService = new google.maps.DirectionsService;
  directionsDisplay = new google.maps.DirectionsRenderer;

  /**
   * Fichada objectivo a tratar.
   *
   * @type {ClockIn}
   * @memberof MapLocationModal
   */
  clockIn: ClockIn = new ClockIn();
  Titulo: String;
  _coordStartLat: number;
  _coordStartLon: number;
  _coordEndLat: number;
  _coordEndtLon: number;
  _StartEnd: number;


  /**
   * Crea una instancia de MapLocationModal:
   *  - Assigna la fichada a partir de los NavParams.
   *  - Prepara el array de productos seleccionables.
   * 
   * 
   * 
   * @param {NavController} navCtrl
   * @param {NavParams} _navParams
   * @memberof MapLocationModal
   */
  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    private _navParams: NavParams)
   {


    this.clockIn = this._navParams.get('data');    
    this._StartEnd = this._navParams.get('tipo');      
    this.Titulo = "FICHADA";
    let CoordStart: string[] = this.clockIn.CoordStart.split(',');
    let CoordEnd: string[] = this.clockIn.CoordEnd.split(',');
    this._coordStartLat = Number( CoordStart[0]);
    this._coordStartLon = Number(CoordStart[1]);
    this._coordEndLat = Number(CoordEnd[0]);
    this._coordEndtLon = Number(CoordEnd[1]);
  }

  ionViewDidLoad(){
    this.initMap();
  }

  initMap() {
    let latLng = new google.maps.LatLng(this._coordStartLat, this._coordStartLon);
    if (this._StartEnd == 2) {
      let latLng = new google.maps.LatLng(this._coordEndLat, this._coordEndtLon);
    }

    let mapOptions = {
      center: latLng,
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    var image = {
      url: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
      // This marker is 20 pixels wide by 32 pixels high.
      size: new google.maps.Size(48, 48),
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(0, 32)
    };

    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.BOUNCE,
      position: latLng,
      label: 'Inicio',
      icon: image
    });

    this.markers.push(marker);
 
    // this.directionsDisplay.setMap(this.map);
  }
/*
  calculateAndDisplayRoute() {
    let latLng = new google.maps.LatLng(this._coordStartLat, this._coordStartLon);
    this.directionsService.route({
      origin: latLng,
      destination: latLng,
      travelMode: 'DRIVING'
    }, (response, status) => {
      if (status === 'OK') {
        this.directionsDisplay.setDirections(response);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }
  */
  /**
   * Cierra el modal sin selección
   *
   * @memberof MapLocationModal
   */
  dismiss(): void {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/maplocation/maplocation.modal.ts